import { Textarea } from "@heroui/react";
import { forwardRef, useEffect, useRef } from "react";
import InputSkeleton from "shared/skeletons/input.skeleton";

interface EditableTextareaProps {
  label?: string;
  focus?: boolean;
  editMode: boolean;
  value: string;
  onChange: (value: string) => void;
  isLoading?: boolean;
  ref?: any;
  onFocus?: () => void;
}

export const EditableTextareaComponent: React.FC<EditableTextareaProps> =
  forwardRef<HTMLTextAreaElement, EditableTextareaProps>(
    (
      {
        label,
        focus = false,
        editMode,
        value,
        onChange,
        isLoading = false, // Assuming default should be false for isLoading
        onFocus,
      },
      ref,
    ) => {
      const internalRef = useRef(null); // Internal ref for direct DOM access

      useEffect(() => {
        if (editMode && internalRef.current && focus) {
          const length = (internalRef.current as any).value.length;
          (internalRef.current as any).focus();
          (internalRef.current as any).setSelectionRange(length, length); // Set cursor position at the end
        }
      }, [editMode]);

      if (isLoading) return <InputSkeleton />;
      if (editMode)
        return (
          <Textarea
            label={label}
            onFocus={onFocus}
            ref={(element) => {
              (internalRef.current as any) = element; // Set internalRef to the DOM element
              if (typeof ref === "function") {
                ref(element);
              } else if (ref) {
                ref.current = element;
              }
            }}
            value={value}
            onChange={(e) => {
              console.log(e.target.value);
              onChange(e.target.value);
            }}
            classNames={{
              input:
                "text-neutral-primary placeholder:text-neutral-secondary-mid",
              inputWrapper:
                "p-2 min-h-fit h-fit rounded-sm bg-white shadow-form-element! data-[hover=true]:bg-white group-data-[focus=true]:bg-white data-[hover=true]:shadow-form-element-hv! group-data-[focus=true]:shadow-form-element-fc!",
            }}
          />
        );
      if (value) return <p className="font-medium">{value}</p>;
      return <p className="font-medium">Niet ingevuld</p>;
    },
  );
